/* Voice search for the Studd Muffyn header search bar (quick-search).
   The mobile band (.smsb) already had a mic; this adds one to the wide bar with
   the "All products" dropdown, on desktop and in the mobile drawer. */
(function () {
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  // Web Speech is Chrome/Edge/Safari only and needs https. Where it is missing we
  // add nothing at all, rather than showing a mic that would do nothing when tapped.
  if (!SR) return;

  var LANG = document.documentElement.getAttribute('data-voice-lang') || 'en-IN';
  var STYLE_ID = 'sm-voice-qs-style';

  function css() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '.smvq{position:absolute;top:50%;transform:translateY(-50%);z-index:3;',
      ' display:flex;align-items:center;justify-content:center;',
      ' width:30px;height:30px;padding:0;border:0;background:none;',
      ' color:currentColor;cursor:pointer;border-radius:50%;',
      ' -webkit-appearance:none;appearance:none}',
      '.smvq svg{width:18px;height:18px;display:block;pointer-events:none}',
      '.smvq:hover{background:rgba(0,0,0,.06)}',
      '.smvq.is-live{color:#c0392b}',
      '.smvq.is-live::after{content:"";position:absolute;inset:0;border-radius:50%;',
      ' border:2px solid currentColor;animation:smvq-pulse 1.1s ease-out infinite}',
      '@keyframes smvq-pulse{0%{transform:scale(.7);opacity:.9}100%{transform:scale(1.25);opacity:0}}',
      '@media (prefers-reduced-motion: reduce){.smvq.is-live::after{animation:none;opacity:.5}}',
      '.smvq-note{position:absolute;left:0;right:0;top:100%;margin-top:6px;z-index:60;',
      ' font-size:12px;line-height:1.4;padding:7px 11px;border-radius:9px;',
      ' background:#193429;color:#fcf4ee;box-shadow:0 6px 18px rgba(0,0,0,.18)}'
    ].join('');
    document.head.appendChild(s);
  }

  function micSVG() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"' +
      ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<rect x="9" y="2.5" width="6" height="11" rx="3"/>' +
      '<path d="M5.5 11.2a6.5 6.5 0 0 0 13 0"/><path d="M12 17.7V21"/></svg>';
  }

  function button(label) {
    var b = document.createElement('button');
    b.type = 'button';                       // never submit the form by itself
    b.className = 'smvq';
    b.setAttribute('aria-label', label);
    b.innerHTML = micSVG();
    return b;
  }

  // ---- one recogniser, pointed at whichever field is in use -----------------
  var rec = new SR();
  rec.lang = LANG;
  rec.interimResults = true;
  rec.continuous = false;
  rec.maxAlternatives = 1;

  var active = null;          // { input, form, mic }
  var finalText = '';
  var listening = false;

  function note(mic, msg) {
    clear(mic);
    if (!msg) return;
    var host = mic.closest('.quick-search__bar') || mic.parentNode;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var n = document.createElement('div');
    n.className = 'smvq-note';
    n.textContent = msg;
    host.appendChild(n);
    mic._note = n;
    mic._noteT = setTimeout(function () { clear(mic); }, 4000);
  }
  function clear(mic) {
    if (mic._noteT) { clearTimeout(mic._noteT); mic._noteT = null; }
    if (mic._note && mic._note.parentNode) mic._note.parentNode.removeChild(mic._note);
    mic._note = null;
  }

  function stop() {
    listening = false;
    if (active && active.mic) {
      active.mic.classList.remove('is-live');
      active.mic.setAttribute('aria-label', 'Search by voice');
    }
  }

  function begin(ctx) {
    if (listening) { try { rec.stop(); } catch (e) {} return; }
    active = ctx;
    finalText = '';
    clear(ctx.mic);
    try { rec.start(); } catch (e) { return; }   // start() throws if already running
    listening = true;
    ctx.mic.classList.add('is-live');
    ctx.mic.setAttribute('aria-label', 'Stop listening');
    note(ctx.mic, 'Listening… say a product or a concern');
  }

  rec.addEventListener('result', function (e) {
    if (!active) return;
    var interim = '';
    for (var i = e.resultIndex; i < e.results.length; i++) {
      var r = e.results[i];
      if (r.isFinal) finalText += r[0].transcript; else interim += r[0].transcript;
    }
    active.input.value = (finalText + interim).trim();
    // let the theme's predictive dropdown react while the sentence is still coming
    active.input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  rec.addEventListener('error', function (e) {
    var mic = active && active.mic;
    stop();
    if (!mic) return;
    note(mic, e.error === 'not-allowed'
      ? 'Microphone is blocked — allow it in your browser settings'
      : (e.error === 'no-speech' ? "Didn't catch that — tap and try again"
                                 : 'Voice search did not work — please type instead'));
  });

  rec.addEventListener('end', function () {
    var ctx = active;
    stop();
    if (!ctx) return;
    var q = ctx.input.value.trim();
    // Only navigate on a settled transcript, or a half-heard phrase would search
    // mid-sentence.
    if (!finalText.trim() || !q) { if (!q) note(ctx.mic, "Didn't catch that — tap and try again"); return; }
    clear(ctx.mic);
    go(ctx.form, ctx.input, q);
  });

  // Build the results URL from the form itself so the "Search within:" dropdown is
  // honoured. Submitting the form would instead hit the theme's own handler, which
  // opens the predictive panel rather than the results page.
  function searchUrl(form, q) {
    if (!form) return '/search?q=' + encodeURIComponent(q) + '&type=product';
    var p = new URLSearchParams();
    try {
      new FormData(form).forEach(function (v, k) { if (v !== '' && v != null) p.append(k, v); });
    } catch (e) { /* fall through to the bare query below */ }
    p.set('q', q);
    return (form.getAttribute('action') || '/search') + '?' + p.toString();
  }

  function go(form, input, q) {
    if (input) input.value = q;
    location.assign(searchUrl(form, q));
  }

  // a handle for checking the built URL from the console on the live site
  window.SMVoiceSearch = { searchUrl: searchUrl, lang: LANG };

  // The theme draws its clear and magnifier icons as ABSOLUTE children of the bar,
  // so a plain flex child lands underneath them. Measure the leftmost of those
  // icons and park the mic just inside it, then pad the field so typed text
  // cannot run under it either.
  function placeMic(mic) {
    var inner = mic.parentNode;
    if (!inner) return;
    if (mic.style.display === 'none') return;
    var box = inner.getBoundingClientRect();
    if (box.width < 40) return;                       // not drawn yet
    var edge = box.right;
    for (var i = 0; i < inner.children.length; i++) {
      var el = inner.children[i];
      if (el === mic) continue;
      if (getComputedStyle(el).position !== 'absolute') continue;
      var b = el.getBoundingClientRect();
      if (b.width > 0 && b.left < edge) edge = b.left;
    }
    var right = Math.max(4, Math.round(box.right - edge) + 6);
    if (mic._right !== right) {                       // only write on change, or the
      mic._right = right;                             // MutationObserver re-fires forever
      mic.style.right = right + 'px';
    }
    var field = inner.querySelector('[data-quick-search-input]') ||
                inner.querySelector('.quick-search__faux-input');
    if (field) {
      var pad = (right + 34) + 'px';
      if (field._smvqPad !== pad) { field._smvqPad = pad; field.style.paddingRight = pad; }
    }
  }

  // ---- attach to every real search field ------------------------------------
  function attachField(input) {
    if (input._smvq) return;
    input._smvq = true;
    var inner = input.parentNode;
    if (!inner) return;
    var mic = button('Search by voice');
    // sit just left of the clear/submit icons so the field keeps its shape
    inner.appendChild(mic);
    if (getComputedStyle(inner).position === 'static') inner.style.position = 'relative';
    placeMic(mic);
    mic.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      begin({ input: input, form: input.closest('form'), mic: mic });
    });
  }

  // ---- and to the collapsed bar people actually see first --------------------
  // That bar is a dummy; tapping it opens the real field. The mic opens it, waits
  // for the field to appear, then starts listening — one tap, not two.
  function attachTrigger(container) {
    if (container._smvq) return;
    container._smvq = true;
    var inner = container.querySelector('.quick-search__bar-inner');
    if (!inner) return;
    var mic = button('Search by voice');
    inner.appendChild(mic);
    if (getComputedStyle(inner).position === 'static') inner.style.position = 'relative';
    placeMic(mic);

    mic.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var opener = inner.querySelector('[data-quick-search-faux-text]');
      if (opener) (opener.closest('button') || opener).click();
      var tries = 0;
      (function wait() {
        var f = visibleField();
        if (f) {
          attachField(f);
          f.focus();
          begin({ input: f, form: f.closest('form'), mic: f.parentNode.querySelector('.smvq') || mic });
          return;
        }
        if (++tries < 30) setTimeout(wait, 60);     // ~1.8s, then give up quietly
      })();
    });
  }

  function visibleField() {
    var all = document.querySelectorAll('[data-quick-search-input]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].getBoundingClientRect().width > 40 && all[i].offsetParent !== null) return all[i];
    }
    return null;
  }

  // The collapsed bar and the real field are two separate DOMs that are both on
  // the page at once, so without this the shopper sees two mics side by side the
  // moment the panel opens. Exactly one is ever shown: the real field's when the
  // panel is open, the collapsed bar's when it is not.
  function onlyOne() {
    var field = visibleField();
    var winner = null;
    if (field) {
      winner = field.parentNode.querySelector('.smvq');
    } else {
      // the desktop and mobile headers each carry a collapsed bar; take the drawn one
      var bars = document.querySelectorAll('.quick-search__trigger-container .smvq');
      for (var i = 0; i < bars.length; i++) {
        if (bars[i].parentNode.getBoundingClientRect().width > 40) { winner = bars[i]; break; }
      }
      if (!winner && bars.length) winner = bars[0];
    }
    document.querySelectorAll('.smvq').forEach(function (m) {
      var want = (m === winner) ? '' : 'none';
      if (m._disp !== want) { m._disp = want; m.style.display = want; }
    });
  }

  var queued = false;
  function scan() {
    css();
    document.querySelectorAll('[data-quick-search-input]').forEach(attachField);
    document.querySelectorAll('.quick-search__trigger-container').forEach(attachTrigger);
    onlyOne();
    document.querySelectorAll('.smvq').forEach(placeMic);
  }
  // the observer below fires on our own style writes too, so coalesce per frame
  function rescan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  // the header re-renders on section load / drawer open, so keep watching
  new MutationObserver(rescan).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', rescan);
  addEventListener('resize', rescan);
  window.SMVoiceSearch.place = scan;
})();
